export enum PaymentType {
  VENMO = "venmo",
  UNKNOWN = "unknown",
  CASH = "cash",
  CREDIT_CARD = "creditCard",
  CHECK = "check",
}
